// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1LinkedWorkItemResourceSchema } from './v1/linkedWorkItemResourceSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const getLinkedWorkItemPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Linked work item ID"),
});

export const getLinkedWorkItemHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Linked work item retrieved successfully
 */
export const getLinkedWorkItem200Schema = z.lazy(() => v1LinkedWorkItemResourceSchema);

/**
 * @description Unauthorized
 */
export const getLinkedWorkItem401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Linked work item not found
 */
export const getLinkedWorkItem404Schema = z.lazy(() => v1NotFoundErrorSchema);

export const getLinkedWorkItemQueryResponseSchema = z.lazy(() => getLinkedWorkItem200Schema);
